import script from "./LeftSidebarFavouriteFixture.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSidebarFavouriteFixture.vue?vue&type=script&setup=true&lang=js"

import "./LeftSidebarFavouriteFixture.vue?vue&type=style&index=0&id=56182f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56182f14"]])

export default __exports__